<div class="cm-report-dialog">
  <div mat-dialog-title class="cm-report-dialog__header">
    <div class="cm-report-dialog__context">Exportação</div>
    <h1 class="cm-report-dialog__title">Exportar sócios PDF</h1>
  </div>

  <div mat-dialog-content class="cm-report-dialog__content">
    <div class="cm-report-dialog__layout">

      <section class="cm-report-dialog__section">
        <div class="cm-report-dialog__section-head">
          <h2>Filtros</h2>
        </div>

        <div class="cm-report-dialog__fields">
          <mat-form-field class="cm-report-dialog__field" appearance="outline">
            <mat-label>Estado</mat-label>
            <mat-select [(ngModel)]="status">
              <mat-option value="all">Todos</mat-option>
              <mat-option value="active">Ativos</mat-option>
              <mat-option value="inactive">Inativos</mat-option>
              <mat-option value="exempt">Isentos</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="cm-report-dialog__year-filter">
            <mat-checkbox [(ngModel)]="filterByYear" (change)="lastPaidYear = null">
              Filtrar por último ano pago
            </mat-checkbox>
            <span class="cm-report-dialog__hint">
              Mostra apenas sócios cujo último pagamento foi no ano selecionado.
            </span>
          </div>

          @if (filterByYear) {
            <mat-form-field class="cm-report-dialog__field" appearance="outline">
              <mat-label>Último ano pago</mat-label>
              <mat-select [(ngModel)]="lastPaidYear">
                @for (y of yearOptions; track y) {
                  <mat-option [value]="y">{{ y }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </section>

      <section class="cm-report-dialog__section cm-report-dialog__section--preview">
        <div class="cm-report-dialog__section-head">
          <h2>O relatório inclui</h2>
        </div>

        <ul class="cm-report-dialog__preview-list">
          <li>Nº de sócio</li>
          <li>Nome</li>
          <li>Ano do último pagamento</li>
          <li>Valor em falta (ano corrente)</li>
          <li>Estado (ativo / inativo / isento)</li>
          <li>Totais por coluna</li>
        </ul>
      </section>

    </div>
  </div>

  <div mat-dialog-actions class="cm-report-dialog__actions">
    <button
      mat-stroked-button
      type="button"
      class="cm-report-dialog__button cm-report-dialog__button--secondary"
      (click)="cancel()">
      Cancelar
    </button>
    <button
      mat-flat-button
      type="button"
      class="cm-report-dialog__button cm-report-dialog__button--primary"
      (click)="confirm()">
      <mat-icon>picture_as_pdf</mat-icon>
      Exportar PDF
    </button>
  </div>
</div>
